package com.imobly.imobly.ui.screens.graphic

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.Text
import androidx.compose.material3.adaptive.currentWindowAdaptiveInfo
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.navigation.compose.rememberNavController
import androidx.window.core.layout.WindowSizeClass.Companion.WIDTH_DP_EXPANDED_LOWER_BOUND
import androidx.window.core.layout.WindowSizeClass.Companion.WIDTH_DP_MEDIUM_LOWER_BOUND
import com.imobly.imobly.ui.components.charts.BarPlotComp
import com.imobly.imobly.ui.components.charts.PieChartComp
import com.imobly.imobly.ui.components.title.TitleComp
import com.imobly.imobly.ui.components.topbar.TopBarComp
import com.imobly.imobly.ui.theme.colors.BackGroundColor
import com.imobly.imobly.ui.theme.colors.TitleColor
import com.imobly.imobly.viewmodel.GraphicViewModel
import imobly.composeapp.generated.resources.Res
import imobly.composeapp.generated.resources.image_logo
import imobly.composeapp.generated.resources.image_logo_complete
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview

@Composable
fun GraphicScreen(graphicViewModel: GraphicViewModel) {
    val verticalScrollState = rememberScrollState()
    
    graphicViewModel.loadGraphics()

    Scaffold(
        topBar = {
            TopBarComp()
        },
        snackbarHost = { SnackbarHost(graphicViewModel.snackMessage.value) }
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .background(BackGroundColor)
                .padding(paddingValues)
                .fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {

            val adaptiveInfo = currentWindowAdaptiveInfo()
            val adaptiveWidth = when {
                adaptiveInfo.windowSizeClass.isWidthAtLeastBreakpoint(WIDTH_DP_EXPANDED_LOWER_BOUND) -> 1100.dp
                adaptiveInfo.windowSizeClass.isWidthAtLeastBreakpoint(WIDTH_DP_MEDIUM_LOWER_BOUND) -> 700.dp
                else -> 600.dp
            }

            TitleComp("Gráficos", fontSize = 32.sp, buttonBackAction = { graphicViewModel.goToHome() })

            Spacer(Modifier.height(30.dp))

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(verticalScrollState),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                ChartContainer(adaptiveWidth, graphicViewModel)
            }
        }
    }
}

@Composable
fun ChartContainer(adaptiveWidth: Dp, graphicViewModel: GraphicViewModel) {

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.padding(top = 10.dp)
    ) {
        Text(
            text = "Comparação de valores pagos por mês",
            color = TitleColor,
            fontWeight = FontWeight.SemiBold,
            fontSize = 18.sp
        )
        BarPlotComp(
            modifier = Modifier
                .width(adaptiveWidth - 200.dp)
                .padding(20.dp),
            xData = graphicViewModel.rentByMonth.value.x,
            yData = graphicViewModel.rentByMonth.value.y
        )
    }

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.padding(top = 10.dp),
    ) {
        Text(
            "Relação de parcelas pagas neste mês",
            color = TitleColor,
            fontWeight = FontWeight.SemiBold,
            fontSize = 18.sp
        )
        PieChartComp(
            modifier = Modifier
                .width(adaptiveWidth - 200.dp)
                .padding(20.dp),
            data = graphicViewModel.rentsPaidThisMonth.value.y,
            labels = graphicViewModel.rentsPaidThisMonth.value.x
        )
    }

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.padding(top = 10.dp)
    ) {
        Text(
            "Relação de propriedades alugadas",
            color = TitleColor,
            fontWeight = FontWeight.SemiBold,
            fontSize = 18.sp
        )
        PieChartComp(
            modifier = Modifier
                .width(adaptiveWidth - 200.dp)
                .padding(20.dp),
            data = graphicViewModel.rentedProperties.value.y,
            labels = graphicViewModel.rentedProperties.value.x
        )
    }
}

@Composable
@Preview
fun GraphicScreenPreview() {
    val navController = rememberNavController()
    GraphicScreen(GraphicViewModel(navController))
}